import { GenericTableColumn } from 'inside-fifa/api/generic-tables/dto';
import { GenericTableColumnAppearance } from './dto';

export const decodeColumnAppearanceState = (column: GenericTableColumn): GenericTableColumnAppearance => {
    if (column.isHidden && !column.shouldShowInExpandableRow) {
        return GenericTableColumnAppearance.Hide;
    }

    if (column.showAsFullWidthRow) {
        return GenericTableColumnAppearance.ShowFullWidthRow;
    }

    if (!column.isHidden && column.isHideOnMobile && column.shouldShowInExpandableRow) {
        return GenericTableColumnAppearance.Responsive;
    }

    if (column.shouldShowInExpandableRow) {
        return GenericTableColumnAppearance.ShowInExpandedRow;
    }

    return GenericTableColumnAppearance.ShowColumn;
};

export const encodeColumnAppearanceState = (appearance: GenericTableColumnAppearance): Partial<GenericTableColumn> => {
    switch (appearance) {
        case GenericTableColumnAppearance.ShowColumn:
            return {
                isHidden: false,
                isHideOnMobile: false,
                shouldShowInExpandableRow: false,
            };

        case GenericTableColumnAppearance.Responsive:
            return {
                isHidden: false,
                isHideOnMobile: true,
                shouldShowInExpandableRow: true,
            };
        case GenericTableColumnAppearance.ShowInExpandedRow:
            return {
                isHidden: true,
                isHideOnMobile: false,
                shouldShowInExpandableRow: true,
            };

        case GenericTableColumnAppearance.Hide:
            return {
                isHidden: true,
                isHideOnMobile: true,
                shouldShowInExpandableRow: false,
            };

        case GenericTableColumnAppearance.ShowFullWidthRow:
            return {
                isHidden: false,
                isHideOnMobile: false,
                shouldShowInExpandableRow: false,
                showAsFullWidthRow: true,
            };
    }
};
